module.exports = __webpack_public_path__ + "img/stock7.9e7e4c3f.png";